module.exports = __webpack_public_path__ + "na.svg?efac2847fb683491ca06372a63adc4d7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/na.svg
// module id = 1528
// module chunks = 0